
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSaveDialogDefineNetwork(
    $timeout, toastr, $filter, $location, $rootScope, NetworkListService, NetworkModel,
    EventServiceEvents, WorkstationListService, WorkstationListPOSTPaging, uuid, SnmpConfigurationService,
    PrinterListService, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/deployAssistant/defineNetwork/saveDialogDefineNetwork/saveDialogDefineNetwork.template.html',
      link: function(scope) {


        const networkDefinition = angular.copy(scope.context.networkDefinition)
        scope.networkDefinition = networkDefinition


        scope.saveComplete = false
        scope.dialogMessage = 'WorkingOnIt'
        let newCreatedNetworks = null
        let customRefence = null

        function Stage () {
          this.start = null;
          this.end = null;
          this.abort = false;
          this.error = false;
        }

        function Task () {
          this.proccessStartTime = new Date().getTime()
          this.stagesCompleted = 0
          this.totalStages = null
          this.printerList = []
          this.snpm = null
          this.retryProxyAttempt = 0
          this.waitMessage = null
          this.messageInterval = null;
          this.stages = {}

          this.createStages = (networkDefinition) => {

            switch(networkDefinition.networkMethod) {
              case 'CREATE_NETWORK':
                this.stages.createNetwork = new Stage()
                this.stages.addGateway = new Stage()
                this.stages.checkForProxy = new Stage()
                this.stages.startDiscovery = new Stage()
                this.stages.proccessDone = new Stage()
                if (networkDefinition.site) {
                  this.stages.addNetworkToSite = new Stage()
                }
              break;
              case 'USE_EXISTING_NETWORK':
                this.stages.addGateway = new Stage()
                this.stages.checkForProxy = new Stage()
                this.stages.startDiscovery = new Stage()
                this.stages.proccessDone = new Stage()
                if (networkDefinition.site) {
                  this.stages.addNetworkToSite = new Stage()
                }
              break;
            }
            this.totalStages = Object.keys(this.stages).length
          }

          this.stageStartTime = (stage) => {
            return this.stages[stage].start = new Date().getTime()
          };

          this.stageEndTime = (stage) => {
            return ((new Date().getTime() - this.stages[stage].start) / 1000).toFixed(2)
          }

          this.proccessEndTime = () => {
            return ((new Date().getTime() - this.proccessStartTime) / 1000).toFixed(2)
          }



          this.showDiscoverMessages = (showMessages) => {
            if (showMessages) {
              this.discoverMessages()
              this.messageInterval = setInterval(this.discoverMessages, 500);
            } else {
              clearInterval(this.messageInterval);
              this.discoverMessages()
            }
          }

          this.discoverMessages = () => {

            const timePassed = new Date().getTime() - this.stages.checkForProxy.start;
            const timeIncrement = 3000

            switch (this.printerList.length <= 0 ) {
              case (timePassed < timeIncrement):
                this.waitMessage = 'SetupWait1'
              break;
              case ((timePassed > timeIncrement) && (timePassed < (timeIncrement * 2))):
                this.waitMessage = 'SetupWait2'
              break;
              case ((timePassed > (timeIncrement * 2)) && (timePassed < (timeIncrement * 3))):
                this.waitMessage = 'SetupWait3'
              break;
              case ((timePassed > (timeIncrement * 3)) && (timePassed < (timeIncrement * 5))):
                this.waitMessage = 'SetupWait4'
              break;
              case ((timePassed > (timeIncrement * 5)) && (timePassed < (timeIncrement * 7))):
                this.waitMessage = 'SetupWait5'
              break;
              case (timePassed < (timeIncrement * 7)):
                this.waitMessage = 'SetupWait6'
              break;
              default:
                this.waitMessage = null
              break;
            }

            if  (this.printerList.length > 0 || this.stages.startDiscovery.end) {
              this.waitMessage = null;
            }

          }

          this.addPrinter = (printerURL) => {
            this.scrollElement = this.scrollElement ? this.scrollElement : document.querySelector(".pingResponseList")

            let that = this;
            PrinterListService.getPrinterByURL(printerURL).then(function(printer) {
              if ( that.printerList.length === 0) {
                that.showDiscoverMessages(false)
              }
              that.printerList.push(printer)

              $timeout(()=> {
                that.scrollElement.scrollTo( 0, that.scrollElement.scrollHeight )
              }, 100)
            }).catch(function(error){});
          }

        }

        scope.task = new Task();
        scope.task.createStages(networkDefinition)


        switch (networkDefinition.networkMethod) {
          case 'CREATE_NETWORK':
            $timeout(() => {
              createNetwork();
            }, 500)
          break;
          case 'USE_EXISTING_NETWORK':
            $timeout(() => {
              newCreatedNetworks = scope.networkDefinition.network
              addGatewayToNewNetwork();
            }, 500)
          break;
        }


        function createNetwork () {
          scope.task.stages.createNetwork.start = scope.task.stageStartTime('createNetwork')

          NetworkListService.addNewNetwork(networkDefinition.network.info.name).then(function(network) {
            newCreatedNetworks = new NetworkModel(network.data)
            setConvertPrintQueueOptionOnNetwork()
          }).catch(function(error) {
            scope.task.stages.createNetwork.end = scope.task.stageEndTime('createNetwork')
            scope.task.stages.createNetwork.abort = true;
            console.log(error);
          });
        }

        function setConvertPrintQueueOptionOnNetwork () {
          let newCreatedNetworksChanged = angular.copy(newCreatedNetworks);
          newCreatedNetworksChanged.info.clientMigratePrintQueues = networkDefinition.convertPrintQueues;
          newCreatedNetworks.saveChanges(newCreatedNetworksChanged).then(function(response) {
            scope.task.stages.createNetwork.end = scope.task.stageEndTime('createNetwork')
            scope.task.stagesCompleted += 1;
            addGatewayToNewNetwork()
          }).catch(function(error) {
            console.log(error);
          });
        }

        function addGatewayToNewNetwork () {
          scope.task.stages.addGateway.start = scope.task.stageStartTime('addGateway')

          let objectToSend = {
            ip: networkDefinition.gwIp,
            mac: networkDefinition.gwMac
          };

          newCreatedNetworks.addGateway(objectToSend).then(function(response) {
            scope.task.stages.addGateway.end = scope.task.stageEndTime('addGateway')
            scope.task.stagesCompleted += 1
            if (networkDefinition.site) {
              addNetworkToSite()
            } else {
              checkForOnlineProxyComputer()
            }
          }).catch(function(error) {
            gatewayConflict(error)
          });
        }

        function gatewayConflict (error) {
          if (error.status === 409) {
            const errorText = error.data.errorText
            let split = errorText.split('[')
            let id = split[1].replace(']', '');
            NetworkListService.getNetworkById(id).then(function(network) {
              scope.task.stages.addGateway.end = scope.task.stageEndTime('addGateway')
              scope.task.stages.addGateway.abort = true;
              scope.task.stages.addGateway.error = network.info.name;
              scope.task.stages.proccessDone.end = scope.task.proccessEndTime()
              if (scope.networkDefinition.networkMethod === 'CREATE_NETWORK') {
                $http.delete(newCreatedNetworks.info._links.self.href).then(function(response) {
                  console.log(response);
                }).catch(function(error) {
                  console.log(error);
                });
              }
            }).catch(function(error) {
              console.log(error);
            });
          }
        }


        function addNetworkToSite() {
          scope.task.stages.addNetworkToSite.start = scope.task.stageStartTime('addNetworkToSite')
          let networkIdArray = [newCreatedNetworks]
          customRefence = `SETUP_ASSISTANT_NETWORK_SITE_UPDATED${uuid.v4()}`
          networkDefinition.site.addNetworksToSite(networkIdArray, customRefence).then(function(response) {
            scope.task.stages.addNetworkToSite.end = scope.task.stageEndTime('addNetworkToSite')
            scope.task.stagesCompleted += 1;
            checkForOnlineProxyComputer();
          }).catch(function(error) {
            scope.task.stages.addNetworkToSite.end = scope.task.stageEndTime('addNetworkToSite')
            scope.task.stages.addNetworkToSite.abort = true;
            console.log(error);
          });
        }

        let retryCounter = 0;
        const retryDelayIncrement = [1000, 2000, 3000, 4000, 5000]
        function checkForOnlineProxyComputer () {
          if (retryCounter === 0) {
            scope.task.stages.checkForProxy.start = scope.task.stageStartTime('checkForProxy')
          }
          scope.task.showDiscoverMessages(true)
          let workstationListPaging = new WorkstationListPOSTPaging();
          workstationListPaging.pagingCriteria.networkFilters = [newCreatedNetworks.info._links.self.href];
          workstationListPaging.pagingCriteria.active = true;
          WorkstationListService.postGetWorkstationListPaged(workstationListPaging).then(function(response) {
            if (response.list.length > 0) {
              scope.task.stages.checkForProxy.end = scope.task.stageEndTime('checkForProxy')
              getSnmpConfiguration();
              scope.task.stagesCompleted += 1;
            } else {
              $timeout(() => {
                if (retryCounter < retryDelayIncrement.length) {
                  scope.task.retryProxyAttempt = retryCounter;
                  retryCounter += 1;
                  checkForOnlineProxyComputer();
                } else {
                  scope.task.stages.proccessDone.end = scope.task.proccessEndTime()
                  scope.task.stages.checkForProxy.end = scope.task.stageEndTime('checkForProxy')
                  scope.task.stages.checkForProxy.abort = true;
                  scope.task.stages.checkForProxy.error = true;
                }
              }, retryDelayIncrement[retryCounter])
            }
          }).catch(function(error) {
            scope.task.stages.checkForProxy.end = scope.task.stageEndTime('checkForProxy')
            scope.task.stages.checkForProxy.abort = true;
          });
        }

        function getSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.task.stagesCompleted++;
            scope.task.snmp = defaultSnmpConfiguration;
            startDiscovery(defaultSnmpConfiguration);
          }).catch(function (response) {
            scope.task.stages.gettingDefaultSnmpConfig.abort = true;
          });
        }


        function startDiscovery (defaultSnmpConfig) {
          scope.task.stages.startDiscovery.start = scope.task.stageStartTime('startDiscovery')

          newCreatedNetworks.discoverNetwork(newCreatedNetworks, defaultSnmpConfig).then(function(response) {

          }).catch(function(error) {
            scope.task.stages.startDiscovery.end = scope.task.stageEndTime('startDiscovery')
            scope.task.stages.startDiscovery.abort = true
          });
        }

        scope.closeAndExit = function () {

          scope.callback()
        }

        let printer_listener = $rootScope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_ADDED, function(name, data) {
          if (data.network === newCreatedNetworks.info._links.self.href) {
            scope.task.addPrinter(data.printer)
          }
        })

        let report_listener = $rootScope.$on(EventServiceEvents.CHANNELS.SPECIFIC_USER.EVENTS.DISCOVERY_REPORT, function(name, data) {
          scope.task.stages.startDiscovery.end = scope.task.stageEndTime('startDiscovery')
          scope.task.stages.proccessDone.end = scope.task.proccessEndTime()
          scope.task.stagesCompleted += 1;
          $timeout(() => {
            toastr.success($filter("stringular")($filter("translate")("FoundPrinters"), scope.task.printerList.length))
          }, 2500)
        });

        scope.$on('$destroy', function() {
          if (scope.task.messageInterval) {
            clearInterval(scope.task.messageInterval)
          }

          printer_listener()
          report_listener()
        });

      }
    };
  }

  pxSaveDialogDefineNetwork.$inject = [
    '$timeout', 'toastr', '$filter', '$location', '$rootScope', 'NetworkListService', 'NetworkModel',
    'EventServiceEvents', 'WorkstationListService', 'WorkstationListPOSTPaging', 'uuid', 'SnmpConfigurationService',
    'PrinterListService', '$http'
  ];

  angular
    .module('printix-admin')
    .directive('pxSaveDialogDefineNetwork', pxSaveDialogDefineNetwork);

})();
